import { useHosRDPs, useResRDPs } from '../../../hooks/useRDPs';
import { useAppView } from '../../../contexts/AppViewContext';
import { useUser } from '../../../contexts/UserContext';
import React from 'react';
import { SectorPanel } from './SectorPanel';
import { SectorToggle } from './SectorToggle';
import { AppViewOption } from './AppViewOption';
import { NoDataFound } from '../../../views/Manage/Inventory/Infrastructure/components/NoDataFound';

export const RDPOptions = ({
  onSelect,
}: {
  onSelect(item: { id: string; code: string; sector: OperatorType }): void;
}) => {
  const hospitality = useHosRDPs();
  const residential = useResRDPs();

  const appView = useAppView();
  const user = useUser();

  const canViewAll = user.permissions.canHos && user.permissions.canRes;

  return (
    <React.Fragment>
      {canViewAll && <SectorToggle />}
      <SectorPanel id="Hospitality">
        <NoDataFound
          trigger={
            hospitality.data !== undefined && hospitality.data.length === 0
          }
          title="No RDPs Found"
          message="There are no Hospitality RDP's yet"
        >
          {hospitality.data &&
            hospitality.data.map((rdp) => (
              <AppViewOption
                key={rdp.code}
                onClick={() =>
                  onSelect({
                    id: rdp.code,
                    code: rdp.code,
                    sector: rdp.type,
                  })
                }
                selected={rdp.code == appView.code}
              >
                <span className="text-left whitespace-nowrap text-ellipsis overflow-hidden w-full">
                  {rdp.name}
                </span>
                <span className="text-left opacity-70 text-xs">{rdp.code}</span>
              </AppViewOption>
            ))}
        </NoDataFound>
      </SectorPanel>

      <SectorPanel id="Residential">
        <NoDataFound
          trigger={
            residential.data !== undefined && residential.data.length === 0
          }
          title="No RDPs Found"
          message="There are no Residential RDP's yet"
        >
          {residential.data &&
            residential.data.map((rdp) => (
              <AppViewOption
                key={rdp.code}
                onClick={() =>
                  onSelect({
                    id: rdp.code,
                    code: rdp.code,
                    sector: rdp.type,
                  })
                }
                selected={rdp.code == appView.code}
              >
                <span className="text-left whitespace-nowrap text-ellipsis overflow-hidden w-full">
                  {rdp.name}
                </span>
                <span className="text-left opacity-70 text-xs">{rdp.code}</span>
              </AppViewOption>
            ))}
        </NoDataFound>
      </SectorPanel>
    </React.Fragment>
  );
};
